<template>
  <div style="display: inline-block">

    <b-modal id="eSimOrderModal" size="md" centered class="bg-light text-black" title="Confirmation">
      <p class="p-0 m-0">
        You are about to order this profile. After this operation the profile should be in the Released state.
      </p>

      <div>
        <label for="apple">
          <input type="checkbox" name="apple" id="apple" v-model="showApple"/>
          Push to Apple Device
        </label>
      </div>

      <div v-if="showApple">
        <div class="input-group pt-2">
          <b-input-group-prepend>
            <base-button size="md">
              <i class="fab fa-apple text-red"></i>
            </base-button>
          </b-input-group-prepend>

          <b-form-input
              id="eid"
              placeholder="eUICC Identifier(EID)"
              v-model="eid"
              :keypress="checkEid()"
              :state="checkEid()"
              aria-describedby="euicc-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="euicc-feedback"
          >This is an optional field and must be 32 digits.
          </b-form-invalid-feedback>
        </div>
      </div>

      <template #modal-footer="{cancel}">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()"> Cancel</b-button>
        <b-button size="sm" variant="danger" @click="apply()"> Apply</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import eSimDashboardService from "@/common/api-services/esim-dashboard-service";
import authService from "@/common/api-services/auth-service";

export default {
  name: "EsimOrderModal",
  data: function () {
    return {
      showApple: false,
      eid: '',
      profileType: '',
      matchingId: '',
      confirmationCode: '',
      device_type: '',
      qrcode: ''
    };
  },
  props: {
    iccid: String,
  },
  methods: {

    checkEid() {
      //console.log("eid:"+this.eid);
      let status = false;
      if (this.eid.length < 1) {
        status = true;
      } else if (this.eid.match(/^[0-9]{32}$/g)) {
        status = true;
      } else {
        status = false;
      }
      //console.log('eid status:'+status)
      return status;
    },


    apply() {
      this.$bvModal.hide("eSimOrderModal");
      // console.log("eid",this.eid)
      // console.log("showApple",this.showApple)

      if (typeof this.eid === 'undefined') this.eid = '';
      if (typeof this.profileType === 'undefined') this.profileType = '';
      if (typeof this.matchingId === 'undefined') this.matchingId = '';
      if (typeof this.confirmationCode === 'undefined') this.confirmationCode = '';
      if (typeof this.device_type === 'undefined') this.device_type = '';
      if (typeof this.qrcode === 'undefined') this.qrcode = '';

      if (this.eid.length === 32 && this.showApple) {
        // console.log("eid",this.eid)
        // console.log("showApple",this.showApple)
        this.device_type = "apple";
      }

      eSimDashboardService.esim_activate(
          this.iccid,
          this.eid,
          this.profileType,
          this.matchingId,
          this.confirmationCode,
          this.device_type,
          this.qrcode
      )
          .then(res => {
            console.log('esim_activate:', res);
            if (!res) throw Error('No response from server.');
            authService.setActivityLog('ESIM:esim_activate ', status + ': ' + this.iccid, 0);
            let status = res.data.header.functionExecutionStatus.status;
            if (status === 'Failed') {
              let message = res.data.header.functionExecutionStatus.statusCodeData.subjectIdentifier;
              throw Error('Order failed with message: ' + status + ' for ' + message);
            } else {
              let res = {
                msg: "ESIM Order was successful: "+this.iccid,
                type: true,
                variant: "success"
              }
              this.$root.$emit("esimProfileToast", res);
            }
          })
          .catch(err => {
            authService.setActivityLog("ESIM:esim_activate FAILED: "+this.iccid, JSON.stringify(err), 1);
            console.log("esim_order error:",err)
            let res = {
              msg: "ESIM Order failed: "+this.iccid,
              type: true,
              variant: "error"
            }
            this.$root.$emit("esimProfileToast", res);
          });

      //reload parent
      this.$root.$emit("esimProfileReloadPage");

    },

  },
};
</script>
